module.exports = __webpack_public_path__ + "assets/img/icon-2.b788be80.png";